import { Link } from "react-router-dom";
import wordImg from "./../assets/images/wardImages/ward1.webp";
import wordImg2 from "./../assets/images/wardImages/ward2.webp";


const clickScroller = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const WordContent = () => {
  return (
<>

    <div className="relative w-full overflow-hidden">

      {/* Images container */}
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 w-full">
          <img
            src={wordImg}
            className="w-full h-auto lg:h-[550px] object-cover"
            alt="Hospital ward"
          />
        </div>
        <div className="lg:w-1/2 w-full">
          <img
            src={wordImg2}
            className="w-full h-auto lg:h-[550px] object-cover"
            alt="Hospital room"
          />
        </div>
      </div>

      {/* Gradient overlay - shows only on lg screens */}
      <div className="hidden lg:block absolute right-0 top-0 bottom-0 w-3/4 bg-gradient-to-l from-blue-800 via-blue-400/70 to-transparent pointer-events-none"></div>
      {/* <div className="hidden lg:block absolute left-0 right-0 top-0 m-6 bottom-0 w-full opacity-45 bg-black shadow-xl rounded-xl pointer-events-none"></div> */}

      {/* Content overlay */}
      <div className="w-full absolute top-0 left-0 h-full flex items-center justify-end p-4 lg:p-0">
        <div className="bg-blue-800/80  lg:bg-transparent rounded-lg lg:rounded-none p-6 lg:p-0 lg:w-4/12 w-full lg:pr-12 lg:py-12">
          <div className="text-center lg:text-left">
            <h1 className="text-3xl lg:text-6xl Blinker-SemiBold mb-4 lg:mb-6 text-white">
              Hospital Wards and Rooms
            </h1>
          </div>
          <div className="leading-tight Blinker-Regular mb-6 lg:mb-8 text-sm lg:text-base text-white">
            <p>
              Exuding warmth and providing complete privacy, our single rooms
              are designed to support your recovery.
              <br />
              <br />
              Access Ceylon Hospital's full range of health services from your
              private room, along with a private bathroom so you can recover
              comfortably.
            </p>
          </div>
          <div className="Blinker-Regular text-center lg:text-left">
            <Link to={"/service/ch-ward"}>
              <button onClick ={clickScroller} className="rounded-lg bg-orange-600 hover:bg-orange-600/75 py-3 px-6 text-white transition-colors duration-300">
                View More Details..
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default WordContent;
